import { api } from '@api'
import { UpdateTicket, Ticket } from '@types'

interface GetTicketsResponse {
  tickets: Ticket[]
}

const updateTicket = async (ticketId: number, ticket: UpdateTicket) => {
  const response = await api.put<GetTicketsResponse>(`/tickets/${ticketId}`, {
    ticket,
  })

  return response.data
}

export const TicketsApi = { updateTicket }
